// extracted by mini-css-extract-plugin
export var closeButton = "_kk-1";
export var closeX = "_kk-3";
export var container = "_kk-0";
export var image = "_kk-2";